import { trackAudioFeedbackEvents } from '@modules/feedback/components/AudioType/utils';
import {
  Forward10Rounded,
  PauseRounded,
  PlayArrowRounded,
  Replay10Rounded,
} from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import { UUID } from 'v2/core/entities/uuid';

interface PlayPauseButtonGroupProps {
  onTogglePlay: () => void;
  isPlaying: boolean;
  onRewind: () => void;
  onForward: () => void;
  isRewindDisabled: boolean;
  isForwardDisabled: boolean;
  feedbackID: UUID;
  isLoading: boolean;
  isDisabled: boolean;
  disabledTooltipTitle?: string;
}

const PlayPauseButtonGroup = ({
  onTogglePlay,
  isPlaying,
  onRewind,
  onForward,
  isRewindDisabled,
  isForwardDisabled,
  feedbackID,
  isLoading,
  isDisabled,
  disabledTooltipTitle,
}: PlayPauseButtonGroupProps) => {
  const handleTogglePlay = () => {
    onTogglePlay();
    trackAudioFeedbackEvents({
      eventName: isPlaying
        ? 'Audio Feedback - Player: Pause Button Clicked'
        : 'Audio Feedback - Player: Play Button Clicked',
      feedbackID,
    });
  };

  const handleRewind = () => {
    onRewind();
    trackAudioFeedbackEvents({
      eventName: 'Audio Feedback - Player: Rewind Button Clicked',
      feedbackID,
    });
  };

  const handleForward = () => {
    onForward();
    trackAudioFeedbackEvents({
      eventName: 'Audio Feedback - Player: Forward Button Clicked',
      feedbackID,
    });
  };

  return (
    <Tooltip
      arrow
      title={isDisabled && disabledTooltipTitle ? disabledTooltipTitle : ''}
      placement="top"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Tooltip placement="top" title="Rewind 10s">
          <Box>
            <IconButton
              size="small"
              color="primary"
              onClick={handleRewind}
              disabled={isRewindDisabled || isDisabled}
            >
              <Replay10Rounded />
            </IconButton>
          </Box>
        </Tooltip>
        {isLoading ? (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width={60}
            height={60}
          >
            <CircularProgress disableShrink size={35} />
          </Stack>
        ) : (
          <IconButton
            color="primary"
            onClick={handleTogglePlay}
            size="small"
            disabled={isDisabled}
          >
            {isPlaying ? (
              <PauseRounded sx={{ fontSize: 50 }} />
            ) : (
              <PlayArrowRounded sx={{ fontSize: 50 }} />
            )}
          </IconButton>
        )}
        <Tooltip placement="top" title="Forward 10s">
          <Box>
            <IconButton
              size="small"
              color="primary"
              onClick={handleForward}
              disabled={isForwardDisabled || isDisabled}
            >
              <Forward10Rounded />
            </IconButton>
          </Box>
        </Tooltip>
      </Stack>
    </Tooltip>
  );
};

export default PlayPauseButtonGroup;
